import { useSyncExternalStore } from 'react';

/** True while the CSS media query matches; re-renders only when that flips. */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const mq = window.matchMedia(query);
      mq.addEventListener('change', onChange);
      return () => mq.removeEventListener('change', onChange);
    },
    () => window.matchMedia(query).matches,
    () => false,
  );
}

/** Tailwind's `md` breakpoint: desktop grids vs phone card lists. */
export const MD_UP = '(min-width: 768px)';
